import { fetchData, getQueryVar } from 'modules/utils'
import { getModuleOptions, select, on } from 'modules/dom'

const MODULE_NAME = 'cee-search-form'
const SELECT_FIELD_SELECTOR = '.js-select'
const INPUT_FIELD_SELECTOR = '.js-input'
const RESET_BUTTON_SELECTOR = '.js-reset-filter'

export default el => {
  const selectField = select(SELECT_FIELD_SELECTOR, el)
  const inputField = select(INPUT_FIELD_SELECTOR, el)
  const resetButton = select(RESET_BUTTON_SELECTOR, el)
  const options = getModuleOptions(MODULE_NAME, el)
  const apiPath = `${options.remote}/wp-json/cee/states`

  const generateStateOptions = (res) => {
    if (res) {
      const optionsHTML = res.reduce(function (result, item) {
        const isSelected = getQueryVar('state') === item.slug ? 'selected' : ''
        return result += `<option value="${item.slug}" ${isSelected}>${item.name}</option>`
      }, '<option value=""></option>')
      if (selectField) selectField.innerHTML = optionsHTML
    }
  }

  fetchData(apiPath).then(generateStateOptions)

  if (resetButton) {
    on('click', () => {
      if (inputField) {
        inputField.value = ''
        inputField.setAttribute('value', '')
      }
      if (selectField) {
        selectField.selectedIndex = 0
        const selectedOption = select('[selected]', selectField)
        if (selectedOption) selectedOption.removeAttribute('selected')
      }
    }, resetButton)
  }
}
